// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"141b300c","703":"86082b9b"}[chunkId] + ".chunk.js";
};